import { Skeleton } from '@/ui/@components/primitives/skeleton';

import { SettingsLayout } from './layout';

const SKELETON_COUNT = 3;

export const SettingsLoading = () => {
  return (
    <SettingsLayout>
      {[...Array(SKELETON_COUNT)].map((_, index) => (
        <Skeleton key={index} className='h-[200px] w-full rounded-xl' />
      ))}
    </SettingsLayout>
  );
};
